<template>
  <div style="display: none">
    {{ touch }}
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import {
  SET_TOUCH
} from '../store/mutation-types'
import store from '../store'

export default {
  name: 'CheckTouch',
  computed: {
    ...mapGetters([
      'touch'
    ])
  },
  methods: {
    ...mapMutations([
      'setTouch'
    ]),
    $_setTouchStore () {
      document.body.removeEventListener('touchstart', this.$_setTouchStore)
      store.commit(SET_TOUCH, true)
    }
  },
  mounted () {
    document.body.addEventListener('touchstart', this.$_setTouchStore)
  }
}
</script>
